import {
  signIn,
  signInV2,
  signOut,
  getAuth,
  onAuth
} from './shared/data/init'

window.rchat = Object.assign({}, window.rchat, {signIn, signInV2, signOut, getAuth, onAuth})


/** WEBPACK FOOTER **
 ** ./modules/rchat.auth.js
 **/